import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  {
    path: routeNames.productCategory,
    component: () => import('../../pages/platformProduct/productCategory/list'),
    meta: { title: '商品列表' }
  },
  {
    path: routeNames.goodSkuList,
    component: () => import('../../pages/platformProduct/goodSkuList/index'),
    meta: { title: '规格管理' }
  },
  {
    path: routeNames.productCategoryEdit,
    component: () => import('../../pages/platformProduct/productCategory/edit'),
    meta: { title: '商品分类线编辑', hideInMenu: true }
  }
  // {
  //   path: routeNames.categoryManagement,
  //   component: () => import('../../pages/tagsManagement/categoryManagement'),
  //   meta: { title: '标签分组管理' }
  // }
] as TRoutes[]
